var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57716 3.76801L10.5638 2.78134C10.6876 2.65747 10.8347 2.55921 10.9965 2.49217C11.1583 2.42513 11.3317 2.39062 11.5068 2.39062C11.682 2.39062 11.8554 2.42513 12.0172 2.49217C12.179 2.55921 12.326 2.65747 12.4498 2.78134L13.3925 3.72401C13.6425 3.97404 13.7829 4.31312 13.7829 4.66667C13.7829 5.02023 13.6425 5.3593 13.3925 5.60934L12.4058 6.59601M9.57716 3.76801L3.16649 10.178C2.94515 10.3994 2.80874 10.6915 2.78116 11.0033L2.61983 12.83C2.61116 12.9271 2.6239 13.0249 2.65714 13.1166C2.69039 13.2082 2.74333 13.2915 2.81223 13.3604C2.88114 13.4294 2.96433 13.4824 3.05595 13.5158C3.14757 13.5491 3.24538 13.5619 3.34249 13.5533L5.16916 13.392C5.48144 13.3647 5.77413 13.2283 5.99583 13.0067L12.4058 6.59601M9.57716 3.76801L12.4058 6.59601",
    stroke: "#001535",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/penIcon.e60a7b7e689341d7ce0933a7699736fb.svg";
export { ForwardRef as ReactComponent };